import { useState, useEffect, useRef } from "react";
import Header from "../../components/Navbar";
import Loader from "../../components/Loader/loader";
import "./buyer.css";
import placeimg from "../../myimgs/Img-No.png";
import { useNavigate } from "react-router-dom";
import { FaListUl, FaMapMarkedAlt } from "react-icons/fa";
import { LoadScriptNext } from "@react-google-maps/api";
import Nearloaction from "../../myimgs/nearlocn.png";
import Swal from "sweetalert2";
import Noprop from "../../myimgs/NestingIndia.png";
import axios from "axios";
import { formatNumberCA } from "../../utils/numberFormat";
import Residin from "../../myimgs/Union (2).png";
import Vectors from "../../myimgs/Vector (4).png";

import {
  // propertyTypes,
  priceList,
  bedsList,
  bathsList,
  squareFootageList,
  storeysList,
  landSizeList,
  maintenanceFeeMonthlyList,
  propertyTaxYearlyList,
  yearBuiltList,
  farmList,
  parkingList,
  buildingStyleList,
  numberOfUnitsList,
  exteriorBuildingSizeList,
  zoningTypeList,
  buildingTypes,
} from "../../data/states";
import resetimg from "../../myimgs/circular (1).png";
const residentialTypes = [
  "Any",
  "Residential",
  "Condo/Strata",
  "Vacant Land",
  "Single Family",
  "Recreational",
  "Multi-family",
  "Agriculture",
  "Parking",
  "Other",
];

const commercialTypes = [
  "Any",
  "Business",
  "Multi-family",
  "Retail",
  "Industrial",
  "Office",
  "Vacant Land",
  "Agriculture",
  "Hospitality",
  "Institutional",
  "Other",
];
// Google Maps components
// const { GoogleMap, Marker, InfoWindow } = require("@react-google-maps/api");
const {
  GoogleMap,
  Marker,
  InfoWindow,
  Circle,
  Autocomplete,
} = require("@react-google-maps/api");
// Map container style
const mapContainerStyle = {
  height: "73vh",
  width: "100%",
  position: "relative",
  borderRadius: "10px",
  right: "0px",
};
const fullScreenMapContainerStyle = {
  height: "100vh",
  width: "100vw",
  position: "fixed",
};
const defaultCenter = {
  lat: 43.7,
  lng: -79.42,
};
// Custom marker icon
const customMarkerIcon = {
  url:
    "data:image/svg+xml;base64," +
    btoa(`
    <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <path fill="#3367d6" stroke="#fff" stroke-width="2" d="M16 2c-5.523 0-10 4.477-10 10 0 7 10 16 10 16s10-9 10-16c0-5.523-4.477-10-10-10z"/>
      <circle fill="#fff" cx="16" cy="12" r="4"/>
    </svg>
  `),
  scaledSize: { width: 32, height: 32 },
  anchor: { x: 16, y: 32 },
};
// Cluster icon generator
const generateClusterIcon = (count) => {
  const size = 40 + Math.min(count / 5, 20); // Size increases with count
  const color = count > 10 ? "#d33636" : count > 5 ? "#d68c36" : "#3367d6";
  return {
    url:
      "data:image/svg+xml;base64," +
      btoa(`
      <svg width="${size}" height="${size}" viewBox="0 0 ${size} ${size}" xmlns="http://www.w3.org/2000/svg">
        <circle cx="${size / 2}" cy="${size / 2}" r="${
          size / 2 - 2
        }" fill="${color}" stroke="#fff" stroke-width="3"/>
        <text x="${size / 2}" y="${
          size / 2 + 4
        }" text-anchor="middle" fill="white" font-weight="bold" font-size="14" font-family="Arial, sans-serif">${count}</text>
      </svg>
    `),
    scaledSize: { width: size, height: size },
    anchor: { x: size / 2, y: size / 2 },
  };
};

const calculateClusters = (markers, zoom) => {
  const clusters = [];
  const clusteredIds = new Set();

  // Larger grid at lower zoom → more clustering
  const baseGridSize = 0.05; // adjust for density
  const gridSize = baseGridSize * Math.pow(2, (10 - zoom) / 1.5);

  markers.forEach((marker, index) => {
    if (clusteredIds.has(marker.propertyId)) return;

    const nearbyMarkers = markers.filter((otherMarker) => {
      if (clusteredIds.has(otherMarker.propertyId)) return false;

      const latDiff = Math.abs(marker.lat - otherMarker.lat);
      const lngDiff = Math.abs(marker.lng - otherMarker.lng);

      // Use gridSize directly (larger = more clustering)
      return latDiff < gridSize && lngDiff < gridSize;
    });

    if (nearbyMarkers.length === 1) {
      clusters.push({
        ...marker,
        isCluster: false,
        count: 1,
      });
    } else {
      const avgLat =
        nearbyMarkers.reduce((sum, m) => sum + m.lat, 0) / nearbyMarkers.length;
      const avgLng =
        nearbyMarkers.reduce((sum, m) => sum + m.lng, 0) / nearbyMarkers.length;

      clusters.push({
        lat: avgLat,
        lng: avgLng,
        isCluster: true,
        count: nearbyMarkers.length,
        markers: nearbyMarkers,
        propertyId: `cluster-${index}`,
        propertyName: `${nearbyMarkers.length} properties`,
      });

      nearbyMarkers.forEach((m) => clusteredIds.add(m.propertyId));
    }
  });

  return clusters;
};
// map,...
function Buyers() {
  const [mapOpen, setMapOpen] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [favorites, setFavorites] = useState([]);
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [search, setSearch] = useState("");
  const [propertyType, setPropertyType] = useState("");
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [mapCenter, setMapCenter] = useState(defaultCenter);
  const [mapZoom, setMapZoom] = useState(12);
  const [clusters, setClusters] = useState([]);
  const mapRef = useRef(null);
  const [appliedFilters, setAppliedFilters] = useState({});
  const [userLocation, setUserLocation] = useState(null);
  const skipNextApplyRef = useRef(false);
  const searchInputRef = useRef(null);
  const pendingApplyRef = useRef(false);
  const arrowUsedRef = useRef(false);
  const [isResidential, setIsResidential] = useState(true); // default Residential
  const propertyTypeOptions = isResidential
    ? residentialTypes
    : commercialTypes;

  const applyOnceRef = useRef(false);
  // const handleEnterApply = (e) => {
  //   if (e.key === "Enter") {
  //     e.preventDefault();
  //     e.stopPropagation(); // 🔥 VERY IMPORTANT
  //     // close suggestions
  //     searchInputRef.current?.blur();
  //     handleApply();
  //   }
  // };

  // const handleEnterApply = (e) => {
  //   if (e.key !== "Enter") return;

  //   // 🔒 If autocomplete dropdown is open, DO NOT APPLY YET
  //   // if (autocompleteRef.current) {
  //   //   pendingApplyRef.current = true;
  //   //   return; // ⛔ stop here
  //   // }

  //   // 🔥 CASE 1: Arrow navigation happened → wait for Google
  //   if (arrowUsedRef.current) {
  //     pendingApplyRef.current = true;
  //     return;
  //   }

  //   // Normal Enter (no autocomplete)
  //   e.preventDefault();
  //   e.stopPropagation();

  //   searchInputRef.current?.blur();
  //   handleApply();
  // };

  const handleEnterApply = (e) => {
    if (e.key !== "Enter") return;

    const hasActiveSuggestion = document.querySelector(
      ".pac-item.pac-item-selected",
    );

    // ✅ Agar arrow se suggestion select hua hai
    if (hasActiveSuggestion || arrowUsedRef.current) {
      // ❌ yaha preventDefault mat karo
      // Google ko Enter handle karne do
      pendingApplyRef.current = true;
      return;
    }

    // ❌ sirf normal typed text ke case me prevent karo
    e.preventDefault();
    e.stopPropagation();

    searchInputRef.current?.blur();
    handleApply();
  };

  // const handleEnterApply = (e) => {
  //   if (e.key !== "Enter") return;

  //   // 🔥 If Google suggestion is highlighted → LET GOOGLE HANDLE IT
  //   const hasActiveSuggestion = document.querySelector(
  //     ".pac-item.pac-item-selected"
  //   );

  //   if (hasActiveSuggestion) {
  //   // ⏳ wait for onPlaceChanged to run
  //   setTimeout(() => {
  //     handleApply(); // ✅ APPLY EVEN FOR ARROW SELECTION
  //   }, 0);
  //   return;
  // }

  //   // ✅ No suggestion selected → manual apply
  //   e.preventDefault();
  //   e.stopPropagation();

  //   searchInputRef.current?.blur();
  //   handleApply();
  // };

  // const handleEnterApply = (e) => {
  //   if (e.key === "Enter") {
  //     e.preventDefault();
  //     e.stopPropagation();

  //     // Let Google finalize selection
  //     // DO NOT manually set search text here

  //     searchInputRef.current?.blur();

  //     applyOnceRef.current = false;
  //     handleApply();
  //   }
  // };

  const getActiveSuggestionFromDOM = () => {
    const active = document.querySelector(".pac-item.pac-item-selected");

    if (!active) return null;

    const mainText = active.querySelector(".pac-item-query")?.textContent || "";

    const secondaryText = active.childNodes[2]?.textContent || "";

    const description = `${mainText}${secondaryText}`.trim();

    return description || null;
  };

  // State to track mode
  const [showNearby, setShowNearby] = useState(false);
  const [showSearchCircle, setShowSearchCircle] = useState(false);
  const [numberOfElements, setNumberOfElements] = useState(0);
  // Pagination states
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [pageSize] = useState(25);
  const navigate = useNavigate();
  const handleViewDetails = (id, propeId) => {
    // Open the route in a new tab with query params
    const url = `/propertyDetail?id=${id}&propeId=${propeId}`;
    window.open(url, "_blank");
  };
  // auctocomplete address ..
  const autocompleteRef = useRef(null);
  const selectedPredictionRef = useRef(null);
  const suppressAutocompleteRef = useRef(false);

  const handleAutocompleteLoad = (autocomplete) => {
    autocompleteRef.current = autocomplete;

    // Canada only restriction
    autocomplete.setOptions({
      componentRestrictions: { country: "ca" },
    });
  };

  // const handlePlaceChanged = () => {
  //   if (!autocompleteRef.current) return;
  //   onPlaceSelect();
  //   const place = autocompleteRef.current.getPlace();
  //   const formatted = place?.formatted_address || place?.name || "";
  //   setSearch(formatted);
  // };

  //
  const handlePlaceChanged = () => {
    if (!autocompleteRef.current) return;

    const place = autocompleteRef.current.getPlace();
    if (!place?.place_id) return;

    const visibleText = searchInputRef.current.value;

    selectedPredictionRef.current = {
      placeId: place.place_id,
      description: visibleText,
    };

    setSearch(visibleText);

    // ✅ KEYBOARD ENTER CASE
    if (pendingApplyRef.current) {
      pendingApplyRef.current = false;
      handleApply();
      return;
    }

    // ✅ MOUSE CLICK CASE (NEW)
    handleApply();
  };

  const moveCursorToEnd = () => {
    const input = searchInputRef.current;
    if (!input) return;

    const length = input.value.length;
    input.setSelectionRange(length, length);
  };

  useEffect(() => {
    return () => {
      autocompleteRef.current = null;
    };
  }, []);

  const geocodeAddress = (address) => {
    return new Promise((resolve, reject) => {
      if (!address || !window.google) return resolve(null);

      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address }, (results, status) => {
        if (status === "OK" && results[0]) {
          const location = results[0].geometry.location;
          resolve({ lat: location.lat(), lng: location.lng() });
        } else {
          console.warn("Geocode failed:", status);
          resolve(null); // or reject(null);
        }
      });
    });
  };

  const getFirstSuggestion = (input) => {
    return new Promise((resolve) => {
      if (!input || !window?.google?.maps?.places) {
        resolve(null);
        return;
      }

      const service = new window.google.maps.places.AutocompleteService();

      service.getPlacePredictions(
        {
          input,
          componentRestrictions: { country: "ca" },
        },
        (predictions, status) => {
          if (
            status === window.google.maps.places.PlacesServiceStatus.OK &&
            predictions?.length
          ) {
            resolve(predictions[0]); // FULL OBJECT
          } else {
            resolve(null);
          }
        },
      );
    });
  };

  // const handleApply = async () => {
  //   if (applyOnceRef.current) return;
  //   applyOnceRef.current = true;

  //   // 🔹 no search
  //   if (!search || !search.trim()) {
  //     fetchProperties(0);
  //     applyOnceRef.current = false;
  //     return;
  //   }

  //   // 🔹 STEP 1: get autocomplete prediction
  //   const service = new window.google.maps.places.AutocompleteService();

  //   service.getPlacePredictions(
  //     {
  //       input: search,
  //       componentRestrictions: { country: "ca" },
  //       // types: ["address"],
  //     },
  //     (predictions, status) => {
  //       if (
  //         status !== window.google.maps.places.PlacesServiceStatus.OK ||
  //         !predictions ||
  //         predictions.length === 0
  //       ) {
  //         // no suggestion → DO NOTHING (important)
  //         applyOnceRef.current = false;
  //         return;
  //       }

  //       const firstPrediction = predictions[0]; // FIRST SUGGESTION

  //       // 🔹 STEP 2: geocode by placeId
  //       const geocoder = new window.google.maps.Geocoder();

  //       geocoder.geocode(
  //         { placeId: firstPrediction.place_id },
  //         (results, status) => {
  //           if (status === "OK" && results?.[0]) {
  //             // const formatted = results[0].formatted_address;
  //             const formatted = firstPrediction.description; // ✅ KEEP USER TEXT

  //             const loc = results[0].geometry.location;

  //             setSearch(formatted);
  //             setMapCenter({
  //               lat: loc.lat(),
  //               lng: loc.lng(),
  //             });

  //             setShowSearchCircle(true);
  //             setShowNearby(false);
  //             localStorage.removeItem("nearby_lat");
  //             localStorage.removeItem("nearby_lng");

  //             //(autocomplete close)
  //             setTimeout(() => {
  //               searchInputRef.current?.blur();
  //             }, 0);

  //             //FINAL API CALL
  //             fetchProperties(0, { searchOverride: formatted });
  //           }

  //           applyOnceRef.current = false;
  //         }
  //       );
  //     }
  //   );
  // };

  const handleApply = async () => {
    if (applyOnceRef.current) return;
    applyOnceRef.current = true;

    if (!search || !search.trim()) {
      fetchProperties(0);
      applyOnceRef.current = false;
      return;
    }

    // ✅ CASE: user selected from autocomplete
    if (selectedPredictionRef.current) {
      const { placeId, description } = selectedPredictionRef.current;

      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ placeId }, (results, status) => {
        if (status === "OK" && results?.[0]) {
          const loc = results[0].geometry.location;

          setMapCenter({ lat: loc.lat(), lng: loc.lng() });
          setShowSearchCircle(true);
          setShowNearby(false);

          fetchProperties(0, { searchOverride: description });
        }

        applyOnceRef.current = false;
      });

      return;
    }

    // ✅ CASE: typed text → FIRST suggestion fallback
    const prediction = await getFirstSuggestion(search);
    if (!prediction) {
      applyOnceRef.current = false;
      return;
    }

    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ placeId: prediction.place_id }, (results, status) => {
      if (status === "OK" && results?.[0]) {
        const loc = results[0].geometry.location;

        setSearch(prediction.description);
        setMapCenter({ lat: loc.lat(), lng: loc.lng() });
        setShowSearchCircle(true);

        fetchProperties(0, {
          searchOverride: prediction.description,
        });
      }

      applyOnceRef.current = false;
    });
  };

  // const handleApply = async () => {
  //   // if (applyOnceRef.current) return;
  //   if (applyOnceRef.current === true) return;
  //   applyOnceRef.current = true;

  //   // ✅ CLOSE SUGGESTION POPUP
  //   // searchInputRef.current?.blur();

  //   if (!search || !search.trim()) {
  //     fetchProperties(0);
  //     applyOnceRef.current = false;
  //     return;
  //   }

  //   // ✅ CASE 1: user selected from dropdown
  //   // if (selectedPredictionRef.current) {
  //   //   const { placeId, description } = selectedPredictionRef.current;

  //   //   const geocoder = new window.google.maps.Geocoder();

  //   //   geocoder.geocode({ placeId }, (results, status) => {
  //   //     if (status === "OK" && results?.[0]) {
  //   //       const loc = results[0].geometry.location;

  //   //       setMapCenter({
  //   //         lat: loc.lat(),
  //   //         lng: loc.lng(),
  //   //       });

  //   //       setShowSearchCircle(true);
  //   //       setShowNearby(false);

  //   //       fetchProperties(0, {
  //   //         searchOverride: description, // ✅ EXACT selected
  //   //       });
  //   //     }

  //   //     applyOnceRef.current = false;
  //   //   });

  //   //   return;
  //   // }

  //   if (
  //     selectedPredictionRef.current &&
  //     !selectedPredictionRef.current.placeId
  //   ) {
  //     applyOnceRef.current = false;
  //     return;
  //   }

  //   if (selectedPredictionRef.current) {
  //     const { placeId, description } = selectedPredictionRef.current;

  //     const geocoder = new window.google.maps.Geocoder();
  //     geocoder.geocode({ placeId }, (results, status) => {
  //       if (status === "OK" && results?.[0]) {
  //         const loc = results[0].geometry.location;

  //         setMapCenter({ lat: loc.lat(), lng: loc.lng() });
  //         setShowSearchCircle(true);
  //         setShowNearby(false);

  //         fetchProperties(0, {
  //           searchOverride: description,
  //         });
  //       }

  //       applyOnceRef.current = false;
  //     });

  //     return;
  //   }

  //   // ✅ CASE 2: user typed & clicked Apply (NO selection)
  //   const service = new window.google.maps.places.AutocompleteService();

  //   service.getPlacePredictions(
  //     {
  //       input: search,
  //       componentRestrictions: { country: "ca" },
  //       // types: ["address"],
  //     },
  //     (predictions, status) => {
  //       if (
  //         status !== window.google.maps.places.PlacesServiceStatus.OK ||
  //         !predictions?.length
  //       ) {
  //         applyOnceRef.current = false;
  //         return;
  //       }

  //       const firstPrediction = predictions[0]; // ✅ fallback only

  //       const geocoder = new window.google.maps.Geocoder();
  //       geocoder.geocode(
  //         { placeId: firstPrediction.place_id },
  //         (results, status) => {
  //           if (status === "OK" && results?.[0]) {
  //             const loc = results[0].geometry.location;

  //             setSearch(firstPrediction.description);
  //             setMapCenter({
  //               lat: loc.lat(),
  //               lng: loc.lng(),
  //             });

  //             setShowSearchCircle(true);

  //             fetchProperties(0, {
  //               searchOverride: firstPrediction.description,
  //             });
  //           }

  //           applyOnceRef.current = false;
  //         }
  //       );
  //     }
  //   );
  // };

  // setmaponsearch ..
  // auctocomplete address ..

  // Helper function — get user location
  const getCurrentLocation = () => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const lat = position.coords.latitude;
            const lng = position.coords.longitude;
            // const lat = 43.6689625;
            // const lng = -79.6707295;
            console.log("User location fetched:", { lat, lng });
            resolve({ lat, lng });
          },
          (error) => {
            console.warn("Location denied or error:", error.message);
            reject(error);
          },
        );
      } else {
        reject(new Error("Geolocation not supported by this browser."));
      }
    });
  };
  // Helper function — get user location

  // Fetch properties with pagination and lat long
  const fetchProperties = async (
    page = 0,
    filters = {},
    userLocation = null,
    residentialValue = isResidential,
  ) => {
    try {
      setLoading(true);

      const baseUrl = process.env.REACT_APP_API_BASE_URL;
      const userId = localStorage.getItem("userId");

      // CLEAN NUMBER (remove commas)
      const cleanNumber = (value) => {
        if (!value) return null;
        return Number(value.toString().replace(/,/g, ""));
      };

      // FORMAT DATE (dd-MM-yyyy)
      const formatDate = (dateStr) => {
        if (!dateStr) return null;
        const [year, month, day] = dateStr.split("-");
        return `${day}-${month}-${year}`;
      };
      const nearbyLat = localStorage.getItem("nearby_lat");
      const nearbyLng = localStorage.getItem("nearby_lng");
      const isNearbyMode = nearbyLat && nearbyLng;
      const finalSearch1 = isNearbyMode
        ? null
        : (filters?.searchOverride ?? search ?? null);

      const effectiveLat =
        userLocation?.lat ??
        (localStorage.getItem("nearby_lat")
          ? Number(localStorage.getItem("nearby_lat"))
          : null);

      const effectiveLng =
        userLocation?.lng ??
        (localStorage.getItem("nearby_lng")
          ? Number(localStorage.getItem("nearby_lng"))
          : null);

      const shouldSendNearby =
        userLocation ||
        (localStorage.getItem("nearby_lat") &&
          localStorage.getItem("nearby_lng"));

      // FINAL REQUEST BODY
      const requestBody = {
        page,
        size: pageSize,
        currentUser: userId,

        // STATIC FLAGS
        sell: false,
        forBidinng: true,
        isApproved: true,

        isResidential: residentialValue,

        latitude: shouldSendNearby ? effectiveLat : null,
        longitude: shouldSendNearby ? effectiveLng : null,

        // BASIC FILTERS
        // search: filters?.searchOverride || search || null,
        search: finalSearch1,
        propertyType: propertyType || propertyTypex || null,

        // PRICE
        propertyValueFrom: cleanNumber(minPrice),
        propertyValueTo: cleanNumber(maxPrice),

        // BEDS / BATHS
        bedRooms: beds || null,
        bathroms: baths || null,

        // SQUARE FOOTAGE
        propertySizeMin: cleanNumber(minSquareFootage),
        propertySizeMax: cleanNumber(maxSquareFootage),

        // MORE FILTERS
        buildingType: buildingType || null,
        farmType: farmType || null,
        parkingType: parkingType || null,
        buildingStyle: buildingStyle || null,

        numberOfUnit: numberOfUnits || null,
        exteriarBuldinngSizeMin: exteriorBuildingSize || null,
        ownershipTitle: ownershipTitle || null,
        zoningType: zoningType || null,
        stories: Stories || null,

        // LAND SIZE
        landSize: landSize || null,

        // LISTED DATE
        listedSince: formatDate(listedSince),

        // MAINTENANCE FEES
        mantainceFeeMonthlyMin: cleanNumber(maintenanceFeeMin),
        mantainceFeeMonthlyMax: cleanNumber(maintenanceFeeMax),

        // PROPERTY TAX
        propertyTaxYearlyMin: cleanNumber(propertyTaxMin),
        propertyTaxYearlyMax: cleanNumber(propertyTaxMax),

        // YEAR BUILT
        yearBuiltFrom: yearBuiltFrom || null,
        yearBuiltTo: yearBuiltTo || null,
      };

      console.log("Final RequestBody:", requestBody);

      // API CALL
      const response = await fetch(`${baseUrl}/property/list`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();
      console.log("Property API Response:", data);
      const finalSearch = filters?.searchOverride || search;
      if (
        !isNearbyMode &&
        finalSearch &&
        finalSearch.trim() !== "" &&
        !showNearby // <-- ADD THIS
      ) {
        geocodeAddress(finalSearch).then((coords) => {
          if (coords) {
            setMapCenter(coords);
            setShowSearchCircle(true);
          }
        });
      }

      // HANDLE RESPONSE
      if (data?.data?.content?.length > 0) {
        const content = data.data.content;

        setProperties(content);
        setTotalPages(data.data.totalPages);
        setTotalElements(data.data.totalElements);
        setNumberOfElements(data.data.numberOfElements);
        //  FAVORITES LOGIC
        const favIds = content
          .filter((item) => item.favorite === true)
          .map((item) => item.id);
        setFavorites(favIds);

        // MAP CENTER LOGIC
        if (userLocation) {
          setMapCenter({ lat: userLocation.lat, lng: userLocation.lng });
        } else if (content[0].latitude && content[0].longitude) {
          setMapCenter({
            lat: Number(content[0].latitude),
            lng: Number(content[0].longitude),
          });
        } else {
          // setMapCenter({ lat: 28.6139, lng: 77.209 });
          setMapCenter(defaultCenter);
        }
      } else {
        setProperties([]);
        setNumberOfElements(0);

        // NO RESULTS MAP CENTER
        if (userLocation) {
          setMapCenter({ lat: userLocation.lat, lng: userLocation.lng });
        } else {
          // setMapCenter({ lat: 28.6139, lng: 77.209 });
          setMapCenter(defaultCenter);
        }
        // favorites logic
        const favIds = properties
          .filter((item) => item.favorite === true)
          .map((item) => item.id);

        setFavorites(favIds);
      }
    } catch (error) {
      console.error("❌ Error fetching properties:", error);
    } finally {
      setLoading(false);
    }
    console.log("properties data ===>", properties);
  };

  // Fetch properties with pagination and lat long

  // on Page Load
  useEffect(() => {
    const initFetch = async () => {
      try {
        const location = await getCurrentLocation();
        // we add this two local storage initaliy for pagination nearbyMe 16-12-2025
        localStorage.setItem("nearby_lat", location.lat);
        localStorage.setItem("nearby_lng", location.lng);
        setUserLocation(location);
        await fetchProperties(
          0,
          { latitude: location.lat, longitude: location.lng, radius: 10 },
          location,
        );
        setShowNearby(true); // by default nearby mode on
      } catch (error) {
        await fetchProperties(0);
        setShowNearby(false); // fallback to all properties
      }
    };

    initFetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // on Page Load
  useEffect(() => {
    const savedLat = localStorage.getItem("nearby_lat");
    const savedLng = localStorage.getItem("nearby_lng");

    if (savedLat && savedLng) {
      setShowNearby(true);

      fetchProperties(
        0,
        {
          latitude: savedLat,
          longitude: savedLng,
          radius: 10,
        },
        { lat: savedLat, lng: savedLng },
      );
    }
  }, []);
  // Toggle Button Handler
  const handleToggleView = async () => {
    if (showNearby) {
      // Nearby was ON → Switch to ALL
      localStorage.removeItem("nearby_lat");
      localStorage.removeItem("nearby_lng");

      setShowNearby(false);

      // call API without nearby
      fetchProperties(0);
    } else {
      // ALL → switch to NEARBY
      try {
        const location = await getCurrentLocation();

        //Clear search because now Nearby mode is ON
        setSearch("");

        // Save to localStorage immediately
        localStorage.setItem("nearby_lat", location.lat);
        localStorage.setItem("nearby_lng", location.lng);

        setShowNearby(true);
        // Clear any active search circle
        setShowSearchCircle(false);

        // Call API with new lat/lng (no reload required)
        fetchProperties(
          0,
          {
            latitude: location.lat,
            longitude: location.lng,
            radius: 10,
            searchOverride: null,
          },
          location,
        );
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops!",
          text: "Location not allowed or unavailable.",
          confirmButtonColor: "#1E88E5",
        });
      }
    }
  };
  // Toggle Button Handler

  // MAP RELATED CODE ...
  // Update clusters when properties or zoom changes
  useEffect(() => {
    console.log(
      "List IDs:",
      properties.map((p) => p.id),
    );
    console.log(
      "Map markers:",
      pagedMapLocations.map((m) => m.propertyId),
    );
    if (pagedMapLocations.length > 0) {
      const newClusters = calculateClusters(pagedMapLocations, mapZoom, null);
      setClusters(newClusters);
    }
  }, [properties, mapZoom]);
  // Update clusters when properties or zoom changes
  // MAP RELATED CODE ...

  // Handle page change
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    // Build filters object
    const filters = {};
    if (search) filters.search = search;
    if (propertyType) filters.propertyType = propertyType;
    if (minPrice) filters.minPrice = minPrice;
    if (maxPrice) filters.maxPrice = maxPrice;
    fetchProperties(newPage, filters);
  };
  // Handle page change
  // filters ..
  const [farmType, setFarmType] = useState("");
  const [parkingType, setParkingType] = useState("");
  const [buildingStyle, setBuildingStyle] = useState("");
  const [numberOfUnits, setNumberOfUnits] = useState("");
  const [exteriorBuildingSize, setExteriorBuildingSize] = useState("");
  const [propertyTypex, setPropertyTypex] = useState("");
  const [listedSince, setListedSince] = useState("");
  // Beds & Baths
  const [beds, setBeds] = useState("");
  const [baths, setBaths] = useState("");
  // Square Footage
  const [minSquareFootage, setMinSquareFootage] = useState("");
  const [maxSquareFootage, setMaxSquareFootage] = useState("");
  // Building Type
  const [buildingType, setBuildingType] = useState("");
  // Storeys
  const [Stories, setStories] = useState("");
  // Ownership / Title
  const [ownershipTitle, setOwnershipTitle] = useState("");
  // Zoning Type
  const [zoningType, setZoningType] = useState("");
  const [landSize, setLandSize] = useState("");

  const [maintenanceFeeMin, setMaintenanceFeeMin] = useState("");
  const [maintenanceFeeMax, setMaintenanceFeeMax] = useState("");

  const [propertyTaxMin, setPropertyTaxMin] = useState("");
  const [propertyTaxMax, setPropertyTaxMax] = useState("");

  const [yearBuiltFrom, setYearBuiltFrom] = useState("");
  const [yearBuiltTo, setYearBuiltTo] = useState("");

  const cleanNumber = (value) => {
    if (!value) return null;
    return Number(value.replace(/,/g, ""));
  };
  const formatDate = (dateStr) => {
    if (!dateStr) return null;

    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  // filters ..

  // Map locations for current page
  const pagedMapLocations = properties
    .map((prop) => {
      if (!prop || prop.latitude == null || prop.longitude == null) return null;

      const lat = Number(prop.latitude);
      const lng = Number(prop.longitude);

      if (
        isNaN(lat) ||
        isNaN(lng) ||
        lat < -90 ||
        lat > 90 ||
        lng < -180 ||
        lng > 180
      ) {
        return null;
      }

      return {
        lat: lat,
        lng: lng,
        propertyId: prop.id,
        propertyName: prop.propertyName,
        property: prop, // Include full property data
      };
    })
    .filter(Boolean);
  // Map locations for current page

  // Countdown component (unchanged)
  function Countdown({ start, end }) {
    const [timeLeft, setTimeLeft] = useState("");

    // const formatDateTime = (dateString) => {
    //   const date = new Date(dateString);
    //   if (isNaN(date)) return "";
    //   const day = String(date.getDate()).padStart(2, "0");
    //   const month = String(date.getMonth() + 1).padStart(2, "0");
    //   const year = date.getFullYear();
    //   const hours = String(date.getHours()).padStart(2, "0");
    //   const minutes = String(date.getMinutes()).padStart(2, "0");
    //   return `${day}-${month}-${year}, ${hours}:${minutes}`;
    // };

    const formatDateTime = (dateString) => {
      if (!dateString) return "";

      const date = new Date(dateString);
      if (isNaN(date)) return "";

      const day = String(date.getUTCDate()).padStart(2, "0");
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      const year = date.getUTCFullYear();

      let hours = date.getUTCHours();
      const minutes = String(date.getUTCMinutes()).padStart(2, "0");

      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12;

      return `${day}-${month}-${year}, ${hours}:${minutes} ${ampm}`;
    };

    const getRemainingTime = (startTime, endTime) => {
      if (!startTime || !endTime) return "";

      const now = new Date();
      const startDate = new Date(startTime);
      const endDate = new Date(endTime);

      if (isNaN(startDate) || isNaN(endDate)) return "";

      // Before start
      if (now < startDate) {
        return (
          <>
            Starts In:
            <br />
            {formatDateTime(startDate)}
          </>
        );
      }

      const diff = endDate - now;
      if (diff <= 0) return "Ended";

      // When started, show Ends In
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      return (
        <>
          Ends In:
          <br />
          {`${days}D : ${hours}H : ${minutes}M : ${seconds}s`}
        </>
      );
    };

    useEffect(() => {
      const interval = setInterval(() => {
        setTimeLeft(getRemainingTime(start, end));
      }, 1000);

      return () => clearInterval(interval);
    }, [start, end]);

    return <h3>{timeLeft || ""}</h3>;
  }
  // Countdown component (unchanged)

  //  pagination buttons
  const renderPaginationButtons = () => {
    if (!properties || properties.length === 0) {
      return null; // nothing will render
    }

    const buttons = [];
    const maxVisiblePages = 4;

    let startPage = Math.max(0, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages - 1, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(0, endPage - maxVisiblePages + 1);
    }

    buttons.push(
      <button
        key="prev"
        disabled={currentPage === 0}
        onClick={() => handlePageChange(currentPage - 1)}
      >
        Prev
      </button>,
    );

    if (startPage > 0) {
      buttons.push(
        <button
          key={0}
          className={currentPage === 0 ? "active" : ""}
          onClick={() => handlePageChange(0)}
        >
          1
        </button>,
      );
      if (startPage > 1) {
        buttons.push(<span key="ellipsis1">...</span>);
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <button
          key={i}
          className={currentPage === i ? "active" : ""}
          onClick={() => handlePageChange(i)}
        >
          {i + 1}
        </button>,
      );
    }

    if (endPage < totalPages - 1) {
      if (endPage < totalPages - 2) {
        buttons.push(<span key="ellipsis2">...</span>);
      }
      buttons.push(
        <button
          key={totalPages - 1}
          className={currentPage === totalPages - 1 ? "active" : ""}
          onClick={() => handlePageChange(totalPages - 1)}
        >
          {totalPages}
        </button>,
      );
    }

    buttons.push(
      <button
        key="next"
        disabled={currentPage === totalPages - 1}
        onClick={() => handlePageChange(currentPage + 1)}
      >
        Next
      </button>,
    );

    return buttons;
  };

  // pagination buttons

  // mAP RELATED CODE ...
  // const MapComponent = ({ listLocations, mapIsOpen }) => {
  // const mapRef = useRef(null);
  const mapReadyRef = useRef(false);
  const prevZoomRef = useRef(null);

  const MapComponent = ({
    listLocations,
    mapIsOpen,
    mapCenter,
    showNearby,
  }) => {
    const mapOptions = {
      minZoom: 2, //  prevents zooming out too far
      maxZoom: 18, // optional, controls max zoom-in
      restriction: {
        // latLngBounds: {
        //   north: 85,
        //   south: -85,
        //   west: -179.9999, //  small tweak prevents wrap -- You can use 180 in both if you want
        //   east: 179.9999,
        // },
        strictBounds: true, //  prevents moving outside world bounds
      },
      zoomControl: true,
      streetViewControl: true,
      mapTypeControl: true,
      fullscreenControl: false,
      noWrap: true,
    };

    const [hoveredMarker, setHoveredMarker] = useState(null);
    const [clusters, setClusters] = useState([]);
    const [mapZoom, setMapZoom] = useState(12);
    const mapRef = useRef(null);
    const currentZoomRef = useRef(null);
    const hideTimeoutRef = useRef(null);
    const [currentMarkers, setCurrentMarkers] = useState(listLocations);
    const isFullscreenRef = useRef(false);

    //Initialize clusters when locations changefGoogleMap
    useEffect(() => {
      if (
        !isFullscreenRef.current &&
        listLocations &&
        listLocations.length > 0
      ) {
        setCurrentMarkers(listLocations);
        const initialZoom = mapRef.current?.getZoom() || 10;
        const initialClusters = calculateClusters(listLocations, initialZoom);
        setClusters(initialClusters);
      } else if (
        !isFullscreenRef.current &&
        listLocations &&
        listLocations.length === 0
      ) {
        setCurrentMarkers([]);
        setClusters([]);
      }
    }, [listLocations]);

    const handleMouseOver = (location) => {
      if (hideTimeoutRef.current) {
        clearTimeout(hideTimeoutRef.current);
        hideTimeoutRef.current = null;
      }
      setHoveredMarker(location);
    };

    const handleMouseOut = () => {
      hideTimeoutRef.current = setTimeout(() => {
        setHoveredMarker(null);
      }, 400);
    };

    const handleZoomChanged = () => {
      if (mapRef.current) {
        const newZoom = mapRef.current.getZoom();

        if (newZoom !== currentZoomRef.current && currentMarkers.length > 0) {
          currentZoomRef.current = newZoom;

          const newClusters = calculateClusters(currentMarkers, newZoom);
          setClusters(newClusters);
          setMapZoom(newZoom);
          console.log(
            `Zoom changed to ${newZoom}. Clustering ${currentMarkers.length} markers.`,
          );
        }
      }
    };
    useEffect(() => {
      if (mapIsOpen && mapRef.current) {
        const timer = setTimeout(() => {
          if (mapRef.current) {
            window.google.maps.event.trigger(mapRef.current, "resize");
            console.log("Map resized triggered via mapIsOpen change.");

            if (listLocations.length > 0) {
              mapRef.current.panTo({
                lat: listLocations[0].lat,
                lng: listLocations[0].lng,
              });
              mapRef.current.setZoom(2);
            }
          }
        }, 50);
        return () => clearTimeout(timer);
      }
    }, [mapIsOpen, listLocations]);
    // Add fullscreen API fetch logic
    // useEffect(() => {
    //   const handleFullscreenChange = () => {
    //     const isFullscreen = !!document.fullscreenElement;
    //     isFullscreenRef.current = isFullscreen;

    //     /* -------- ENTER FULLSCREEN -------- */
    //     if (isFullscreen) {
    //       console.log("Entered fullscreen → open new tab & exit fullscreen");

    //       if (!window.__mapTabOpened) {
    //         window.__mapTabOpened = true;

    //         // ✅ open map in new tab
    //         window.open("/map", "_blank", "noopener,noreferrer");

    //         // ✅ EXIT fullscreen in current tab
    //         setTimeout(() => {
    //           if (document.fullscreenElement) {
    //             document.exitFullscreen();
    //           }
    //         }, 50);
    //       }

    //       return;
    //     }

    //     /* -------- EXIT FULLSCREEN -------- */
    //     console.log("Exited fullscreen");
    //     window.__mapTabOpened = false;
    //   };

    //   document.addEventListener("fullscreenchange", handleFullscreenChange);
    //   document.addEventListener(
    //     "webkitfullscreenchange",
    //     handleFullscreenChange
    //   );
    //   document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    //   document.addEventListener("msfullscreenchange", handleFullscreenChange);

    //   return () => {
    //     document.removeEventListener(
    //       "fullscreenchange",
    //       handleFullscreenChange
    //     );
    //     document.removeEventListener(
    //       "webkitfullscreenchange",
    //       handleFullscreenChange
    //     );
    //     document.removeEventListener(
    //       "mozfullscreenchange",
    //       handleFullscreenChange
    //     );
    //     document.removeEventListener(
    //       "msfullscreenchange",
    //       handleFullscreenChange
    //     );
    //   };
    // }, []);

    useEffect(() => {
      if (!mapCenter) return;
      const applyPanZoom = () => {
        if (!mapRef.current) return false;

        try {
          const lat = Number(mapCenter.lat);
          const lng = Number(mapCenter.lng);
          if (Number.isNaN(lat) || Number.isNaN(lng)) return false;

          // one combined flag for zoom state
          const zoomActive = showNearby || showSearchCircle;
          // const zoomActive =
          //   showNearby ||
          //   showSearchCircle ||
          //   (properties && properties.length > 0); // zoom when results available

          // save previous zoom when activating zoom mode
          const currentZoom = mapRef.current.getZoom();
          if (zoomActive && prevZoomRef.current == null) {
            prevZoomRef.current = currentZoom;
          }

          // set new center
          mapRef.current.setCenter({ lat, lng });

          // handle zoom
          if (zoomActive) {
            if (!properties?.length || properties.length === 0) {
              const restoreZoom = prevZoomRef.current ?? 2;
              mapRef.current.setZoom(restoreZoom);
              prevZoomRef.current = null;
            } else {
              mapRef.current.setZoom(11); // zoomed-in value
            }
          } else {
            const restoreZoom = prevZoomRef.current ?? 2;
            mapRef.current.setZoom(restoreZoom);
            prevZoomRef.current = null;
          }

          return true;
        } catch (err) {
          console.warn("applyPanZoom error:", err);
          return false;
        }
      };

      // If map ready, try immediately
      if (mapReadyRef.current && mapRef.current) {
        const ok = applyPanZoom();
        if (ok) return;
      }

      // If not ready or apply failed, retry briefly (defensive)
      let tries = 0;
      const maxTries = 6;
      const interval = setInterval(() => {
        tries += 1;
        if (applyPanZoom() || tries >= maxTries) {
          clearInterval(interval);
        }
      }, 150);

      return () => clearInterval(interval);
    }, [mapCenter, showNearby]);

    return (
      <GoogleMap
        mapContainerStyle={
          !!document.fullscreenElement
            ? fullScreenMapContainerStyle
            : mapContainerStyle
        }
        // center={defaultCenter}
        center={mapCenter || defaultCenter}
        // zoom={2}
        options={mapOptions}
        onZoomChanged={handleZoomChanged}
        onLoad={(map) => {
          mapRef.current = map;
          currentZoomRef.current = map.getZoom();
          prevZoomRef.current = map.getZoom();
          mapReadyRef.current = true;
          setMapZoom(map.getZoom());

          if (listLocations.length > 0) {
            map.panTo({ lat: listLocations[0].lat, lng: listLocations[0].lng });
            map.setZoom(2);
          }
        }}
      >
        {clusters.map((cluster) => (
          <Marker
            key={cluster.propertyId}
            position={{ lat: cluster.lat, lng: cluster.lng }}
            icon={
              cluster.isCluster
                ? generateClusterIcon(cluster.count)
                : customMarkerIcon
            }
            onClick={() => {
              setHoveredMarker(cluster);
              if (
                cluster.isCluster &&
                cluster.markers.length > 1 &&
                mapRef.current
              ) {
                mapRef.current.panTo({ lat: cluster.lat, lng: cluster.lng });
                mapRef.current.setZoom(mapZoom + 2);
              }
            }}
          />
        ))}

        {hoveredMarker && (
          <InfoWindow
            position={{ lat: hoveredMarker.lat, lng: hoveredMarker.lng }}
            onCloseClick={() => setHoveredMarker(null)}
            onMouseOver={() => {
              if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
            }}
            onMouseOut={handleMouseOut}
          >
            <div>
              <h4 style={{ margin: "0 0 8px 0", fontSize: "14px" }}>
                {hoveredMarker.isCluster
                  ? `${hoveredMarker.count} Properties`
                  : hoveredMarker.propertyName}
              </h4>

              <div>
                {(hoveredMarker.isCluster
                  ? hoveredMarker.markers
                  : [hoveredMarker]
                ).map((marker, index) => {
                  const prop = marker.property || {};
                  const imageUrl =
                    prop.propertyImages && prop.propertyImages.length > 0
                      ? prop.propertyImages[0].imageUrl
                      : placeimg;

                  // Real dynamic price
                  const price = (() => {
                    if (prop.liveBid) {
                      return `$${Number(prop.liveBid).toLocaleString()}`;
                    }

                    const details = prop.biddingDetails;
                    if (!details) {
                      return prop.desiredPropertyValue
                        ? `$${Number(
                            prop.desiredPropertyValue,
                          ).toLocaleString()}`
                        : "$N/A";
                    }

                    const { currenntAuctionAmount, offerStartingPrice } =
                      details;
                    if (currenntAuctionAmount != null)
                      return `$${Number(
                        currenntAuctionAmount,
                      ).toLocaleString()}`;
                    if (offerStartingPrice != null)
                      return `$${Number(offerStartingPrice).toLocaleString()}`;
                    return "$N/A";
                  })();

                  return (
                    <div key={index}>
                      <div className="makerimg">
                        <img src={imageUrl} alt="property" />
                      </div>

                      <div className="propnflx">
                        {prop.propertySubType || "No Name"}
                        <div
                          style={{
                            display: "flex",
                            gap: "8px",
                            fontSize: "12px",
                            color: "#666",
                            alignItems: "center",
                          }}
                        >
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            🛏 {prop.bedroomsTotal ?? "N/A"}
                          </span>
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            🛁 {prop.bathroomsTotalInteger ?? "N/A"}
                          </span>
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            📐{" "}
                            {prop.lotSizeArea
                              ? `${prop.lotSizeArea} sqft`
                              : "N/A"}
                          </span>
                        </div>
                      </div>

                      <div className="peoicer">
                        <h4 className="prices">
                          {(() => {
                            if (prop.liveBid) {
                              return `$${Number(
                                prop.liveBid,
                              ).toLocaleString()}`;
                            }

                            const details = prop.biddingDetails;

                            if (!details) {
                              return `$${
                                prop.listPrice?.toLocaleString() || "N/A"
                              }`;
                            }

                            const {
                              currenntAuctionAmount,
                              offerStartingPrice,
                            } = details;

                            if (
                              currenntAuctionAmount !== null &&
                              currenntAuctionAmount !== undefined
                            ) {
                              return `$${Number(
                                currenntAuctionAmount,
                              ).toLocaleString()}`;
                            }

                            if (
                              offerStartingPrice !== null &&
                              offerStartingPrice !== undefined
                            ) {
                              return `$${Number(
                                offerStartingPrice,
                              ).toLocaleString()}`;
                            }

                            return "$N/A";
                          })()}
                        </h4>

                        <button
                          className="VIEWMAKER"
                          onClick={() => {
                            handleViewDetails(prop.id, prop.propeId);
                            setHoveredMarker(null);
                          }}
                        >
                          View
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </InfoWindow>
        )}

        {/* Search Circle */}
        {showSearchCircle && mapCenter && (
          <Circle
            center={{
              lat: Number(mapCenter.lat),
              lng: Number(mapCenter.lng),
            }}
            radius={15000} // Search radius 8km or whatever you want
            options={{
              strokeColor: "#144788",
              strokeOpacity: 0.9,
              strokeWeight: 2,
              fillColor: "#144788",
              fillOpacity: 0.15,
              clickable: false,
              draggable: false,
              editable: false,
              zIndex: 2,
            }}
          />
        )}

        {/* Nearby Circle */}
        {/* {showNearby && mapCenter && (
          <Circle
            center={{
              lat: Number(mapCenter.lat),
              lng: Number(mapCenter.lng),
            }}
            radius={15000} // 15 km for nearby
            options={{
              strokeColor: "#144788",
              strokeOpacity: 0.9,
              strokeWeight: 2,
              fillColor: "#144788",
              fillOpacity: 0.15,
              clickable: false,
              draggable: false,
              editable: false,
              zIndex: 2,
            }}
          />
        )} */}
        {showNearby &&
          localStorage.getItem("nearby_lat") &&
          localStorage.getItem("nearby_lng") && (
            <Circle
              center={{
                lat: Number(localStorage.getItem("nearby_lat")),
                lng: Number(localStorage.getItem("nearby_lng")),
              }}
              radius={15000} // 15 km for nearby
              options={{
                strokeColor: "#144788",
                strokeOpacity: 0.9,
                strokeWeight: 2,
                fillColor: "#144788",
                fillOpacity: 0.15,
                clickable: false,
                draggable: false,
                editable: false,
                zIndex: 2,
              }}
            />
          )}

        {/* Nearby Marker ONLY for Nearby Mode */}

        {showNearby &&
          localStorage.getItem("nearby_lat") &&
          localStorage.getItem("nearby_lng") && (
            <Marker
              position={{
                lat: Number(localStorage.getItem("nearby_lat")),
                lng: Number(localStorage.getItem("nearby_lng")),
              }}
              icon={{
                url: "https://maps.google.com/mapfiles/ms/icons/red-dot.png",
                scaledSize: new window.google.maps.Size(40, 40),
                anchor: new window.google.maps.Point(20, 40),
              }}
              zIndex={3}
            />
          )}
      </GoogleMap>
    );
    // mAP RELATED CODE ...
  };
  // mAP RELATED CODE ...
  // favraotsosdcodc..c
  const toggleFavorite = async (propeId, propertyId, listingId) => {
    const userId = localStorage.getItem("userId");

    if (!userId) {
      Swal.fire({
        title: "Login Required",
        text: "Please login first to add properties to your favorites.",
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#3085d6",
      });
      return;
    }

    // optimistic UI
    setFavorites((prev) =>
      prev.includes(propertyId)
        ? prev.filter((favId) => favId !== propertyId)
        : [...prev, propertyId],
    );

    try {
      const baseURL = process.env.REACT_APP_API_BASE_URL;
      let url = "";

      // if (propertyId && propertyId !== "null" && propertyId !== "") {
      //   url = `${baseURL}/favorites/mark?userId=${userId}&propertyId=${propertyId}`;
      // } else if (listingId) {
      //   url = `${baseURL}/favorites/mark?userId=${userId}&listingId=${listingId}`;
      // } else {
      //   console.error("Both propertyId and listingId are missing");
      //   return;
      // }
      console.log("prop...........", propeId);

      if (propeId && propeId !== "null" && propeId !== "") {
        url = `${baseURL}/favorites/mark?userId=${userId}&propertyId=${propertyId}`;
      } else {
        url = `${baseURL}/favorites/mark?userId=${userId}&listingId=${listingId}`;
      }

      const response = await axios.post(url);

      if (response.status === 200) {
        console.log("Favorite updated successfully:", response.data);
      }
    } catch (error) {
      console.error("Error updating favorite:", error);
    }
  };

  // favratord..
  return (
    <>
      <div className="myallcs">
        <Header />
        <div className="listing-container scrolleffectnm">
          {/*Search Bar & Filters */}
          <div className="filter-btn-wrap">
            <div className="main-search-bar byurf mapsercgh">
              {/* Search Input */}
              <div>
                <LoadScriptNext
                  googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                  libraries={["places"]}
                >
                  <Autocomplete
                    onLoad={handleAutocompleteLoad}
                    onPlaceChanged={handlePlaceChanged}
                  >
                    <input
                      ref={searchInputRef}
                      type="text"
                      value={search}
                      onChange={(e) => {
                        setSearch(e.target.value);
                        selectedPredictionRef.current = null; //reset if user types
                        // unlock autocomplete ONLY when user types
                        suppressAutocompleteRef.current = false;
                        arrowUsedRef.current = false; // reset when typing

                        if (showNearby) {
                          setShowNearby(false);
                          localStorage.removeItem("nearby_lat");
                          localStorage.removeItem("nearby_lng");
                        }
                      }}
                      // onKeyDownCapture={handleEnterApply}
                      onKeyDownCapture={(e) => {
                        if (e.key === "ArrowDown" || e.key === "ArrowUp") {
                          arrowUsedRef.current = true; // user navigated list
                        }
                        handleEnterApply(e);
                      }}
                    />
                  </Autocomplete>
                </LoadScriptNext>
              </div>

              {/* Property Type Filter */}
              <select
                className="select-input"
                value={propertyType}
                onChange={(e) => setPropertyType(e.target.value)}
                onKeyDown={handleEnterApply}
              >
                <option value="">Property Type</option>
                {propertyTypeOptions.map((type, index) => (
                  <option key={index} value={type}>
                    {type}
                  </option>
                ))}
              </select>

              {/* Min Price Filter */}
              <select
                value={minPrice}
                onChange={(e) => setMinPrice(e.target.value)}
                onKeyDown={handleEnterApply}
              >
                <option value="">No Min</option>
                {priceList.map((price, index) => (
                  <option key={index} value={price}>
                    ${price}
                  </option>
                ))}
              </select>

              {/* Max Price Filter */}
              <select
                value={maxPrice}
                onChange={(e) => setMaxPrice(e.target.value)}
                onKeyDown={handleEnterApply}
              >
                <option value="">No Max</option>
                {priceList.map((price, index) => (
                  <option key={index} value={price}>
                    ${price}
                  </option>
                ))}
              </select>

              <button
                className="filter-btn"
                onClick={() => setShowFilter(true)}
                style={{ width: "50%" }}
              >
                More Filter
              </button>

              {/* Apply Button */}
              {/* <button
                className="applyfilter"
                onClick={() => fetchProperties(0)}
                disabled={!search && !propertyType && !minPrice && !maxPrice} // disable if all are empty
                style={{
                  opacity:
                    !search && !propertyType && !minPrice && !maxPrice
                      ? 0.6
                      : 1,
                  cursor:
                    !search && !propertyType && !minPrice && !maxPrice
                      ? "not-allowed"
                      : "pointer",
                }}
              >
                Apply
              </button> */}
              <button
                className="applyfilter"
                onClick={handleApply}
                disabled={!search && !propertyType && !minPrice && !maxPrice}
                style={{
                  opacity:
                    !search && !propertyType && !minPrice && !maxPrice
                      ? 0.6
                      : 1,
                  cursor:
                    !search && !propertyType && !minPrice && !maxPrice
                      ? "not-allowed"
                      : "pointer",
                }}
              >
                Apply
              </button>
            </div>

            <div className="newflx">
              <button
                onClick={handleToggleView}
                style={{
                  backgroundColor: showNearby ? "rgb(20 71 136)" : "#f0f0f0",
                  color: "#fff",
                  border: "none",
                  borderRadius: "30px",
                  padding: "8px 16px",
                  cursor: "pointer",
                  width: "43px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img src={Nearloaction} className="nerlocin" />
              </button>
              <button
                className="filter-btn kioklki"
                onClick={() => setShowFilter(true)}
                style={{ width: "50%" }}
              >
                Filter
              </button>

              <button
                className="map-toggle-btn filtersbutton"
                onClick={() => setMapOpen(!mapOpen)}
              >
                {mapOpen ? (
                  <FaListUl size={22} />
                ) : (
                  <FaMapMarkedAlt size={22} />
                )}
              </button>
            </div>
          </div>

          {/*Filter Modal - Keep this section as is */}
          {showFilter && (
            <div className="filter-modal">
              <div className="filter-content">
                <span
                  className="close-btnbyr"
                  onClick={() => setShowFilter(false)}
                >
                  &times;
                </span>

                <div className="filter-grid-advanced">
                  {/* Property Type */}
                  <div className="filter-item">
                    <label>Property Type</label>
                    <select
                      value={propertyTypex}
                      onChange={(e) => setPropertyTypex(e.target.value)}
                    >
                      {propertyTypeOptions.map((type, index) => (
                        <option key={index} value={type}>
                          {type}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Price */}
                  <div className="filter-item">
                    <label>Price</label>
                    <div className="range-inputs">
                      <select
                        value={minPrice}
                        onChange={(e) => setMinPrice(e.target.value)}
                      >
                        <option value="">No Min</option>
                        {priceList.map((price, index) => (
                          <option key={index} value={price}>
                            ${price}
                          </option>
                        ))}
                      </select>

                      <select
                        value={maxPrice}
                        onChange={(e) => setMaxPrice(e.target.value)}
                      >
                        <option value="">No Max</option>
                        {priceList.map((price, index) => (
                          <option key={index} value={price}>
                            ${price}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* ===== RESIDENTIAL ONLY FIELDS ===== */}
                  {isResidential && (
                    <>
                      {/* Farm Type */}
                      {propertyTypex === "Agriculture" && (
                        <div className="filter-item">
                          <label>Farm Type</label>
                          <select
                            value={farmType}
                            onChange={(e) => setFarmType(e.target.value)}
                          >
                            <option value="">Any</option>
                            {farmList.map((farm, index) => (
                              <option key={index} value={farm}>
                                {farm}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}

                      {/* Parking Type */}
                      {propertyTypex === "Parking" && (
                        <div className="filter-item">
                          <label>Parking Type</label>
                          <select
                            value={parkingType}
                            onChange={(e) => setParkingType(e.target.value)}
                          >
                            <option value="">Any</option>
                            {parkingList.map((p, index) => (
                              <option key={index} value={p}>
                                {p}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}

                      {/* Beds */}
                      {propertyTypex !== "Vacant Land" &&
                        propertyTypex !== "Multi Family" &&
                        propertyTypex !== "Parking" && (
                          <div className="filter-item">
                            <label>Beds</label>
                            <select
                              value={beds}
                              onChange={(e) => setBeds(e.target.value)}
                            >
                              {bedsList.map((b, i) => (
                                <option key={i} value={b}>
                                  {b}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}

                      {/* Baths */}
                      {propertyTypex !== "Vacant Land" &&
                        propertyTypex !== "Multi Family" &&
                        propertyTypex !== "Parking" && (
                          <div className="filter-item">
                            <label>Baths</label>
                            <select
                              value={baths}
                              onChange={(e) => setBaths(e.target.value)}
                            >
                              {bathsList.map((b, i) => (
                                <option key={i} value={b}>
                                  {b}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}

                      {/* Square Footage */}
                      {propertyTypex !== "Vacant Land" &&
                        propertyTypex !== "Parking" && (
                          <div className="filter-item">
                            <label>Square Footage</label>
                            <div className="range-inputs">
                              <select
                                value={minSquareFootage}
                                onChange={(e) =>
                                  setMinSquareFootage(e.target.value)
                                }
                              >
                                <option value="">No Min</option>
                                {squareFootageList.map((sqft, index) => (
                                  <option key={index} value={sqft}>
                                    {sqft}
                                  </option>
                                ))}
                              </select>

                              <select
                                value={maxSquareFootage}
                                onChange={(e) =>
                                  setMaxSquareFootage(e.target.value)
                                }
                              >
                                <option value="">No Max</option>
                                {squareFootageList.map((sqft, index) => (
                                  <option key={index} value={sqft}>
                                    {sqft}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        )}
                    </>
                  )}

                  {/* ===== COMMON FIELDS (Residential + Commercial) ===== */}

                  {/* Building Type */}
                  <div className="filter-item">
                    <label>Building Type</label>
                    <select
                      value={buildingType}
                      onChange={(e) => setBuildingType(e.target.value)}
                    >
                      <option value="">Building Type</option>
                      {buildingTypes.map((type, index) => (
                        <option key={index} value={type}>
                          {type}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Maintenance Fees */}
                  <div className="filter-item">
                    <label>Maintenance Fees - Monthly</label>
                    <div className="range-inputs">
                      <select
                        value={maintenanceFeeMin}
                        onChange={(e) => setMaintenanceFeeMin(e.target.value)}
                      >
                        <option value="">No Min</option>
                        {maintenanceFeeMonthlyList.map((fee, index) => (
                          <option key={index} value={fee}>
                            {fee}
                          </option>
                        ))}
                      </select>

                      <select
                        value={maintenanceFeeMax}
                        onChange={(e) => setMaintenanceFeeMax(e.target.value)}
                      >
                        <option value="">No Max</option>
                        {maintenanceFeeMonthlyList.map((fee, index) => (
                          <option key={index} value={fee}>
                            {fee}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Property Tax */}
                  <div className="filter-item">
                    <label>Property Tax - Yearly</label>
                    <div className="range-inputs">
                      <select
                        value={propertyTaxMin}
                        onChange={(e) => setPropertyTaxMin(e.target.value)}
                      >
                        <option value="">No Min</option>
                        {propertyTaxYearlyList.map((tax, index) => (
                          <option key={index} value={tax}>
                            {tax}
                          </option>
                        ))}
                      </select>

                      <select
                        value={propertyTaxMax}
                        onChange={(e) => setPropertyTaxMax(e.target.value)}
                      >
                        <option value="">No Max</option>
                        {propertyTaxYearlyList.map((tax, index) => (
                          <option key={index} value={tax}>
                            {tax}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Year Built */}
                  <div className="filter-item">
                    <label>Years Built</label>
                    <div className="range-inputs">
                      <select
                        value={yearBuiltFrom}
                        onChange={(e) => setYearBuiltFrom(e.target.value)}
                      >
                        <option value="">No Min</option>
                        {yearBuiltList.map((year, index) => (
                          <option key={index} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>

                      <select
                        value={yearBuiltTo}
                        onChange={(e) => setYearBuiltTo(e.target.value)}
                      >
                        <option value="">No Max</option>
                        {yearBuiltList.map((year, index) => (
                          <option key={index} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                {/* Buttons */}
                <div className="filter-actions-advanced">
                  <button
                    className="reset-btn"
                    onClick={() => {
                      setSearch("");
                      setPropertyType("");
                      setMinPrice("");
                      setMaxPrice("");
                      setBeds("");
                      setBaths("");
                      setPropertyTypex("");
                      setFarmType("");
                      setParkingType("");
                      setBuildingStyle("");
                      setNumberOfUnits("");
                      setExteriorBuildingSize("");
                      setOwnershipTitle("");
                      setZoningType("");
                      setLandSize("");
                      setMinSquareFootage("");
                      setMaxSquareFootage("");
                      setBuildingType("");
                      setStories("");
                      fetchProperties();
                    }}
                  >
                    <img src={resetimg} alt="" /> Reset Filter
                  </button>

                  <button
                    className="apply-btn"
                    onClick={() => {
                      const applied = {
                        search,
                        propertyTypex,
                        minPrice,
                        maxPrice,
                        farmType,
                        parkingType,
                        beds,
                        baths,
                        minSquareFootage,
                        maxSquareFootage,
                        buildingType,
                        Stories,
                        ownershipTitle,
                        numberOfUnits,
                        exteriorBuildingSize,
                        landSize,
                        zoningType,
                        listedSince,
                        maintenanceFeeMin,
                        maintenanceFeeMax,
                        propertyTaxMin,
                        propertyTaxMax,
                        yearBuiltFrom,
                        yearBuiltTo,
                      };

                      setAppliedFilters(applied);
                      fetchProperties();
                      setShowFilter(false);
                    }}
                  >
                    Apply Filter
                  </button>
                </div>
              </div>
            </div>
          )}

          <div className="showfilters">
            {Object.keys(appliedFilters).length > 0 && (
              <div className="applied-filters">
                <h4>
                  Applied <br></br>Filters:
                </h4>
                <ul>
                  {Object.entries(appliedFilters)
                    .filter(([key, value]) => value !== "")
                    .map(([key, value]) => (
                      <li key={key}>
                        <strong>{key}:</strong> <br></br>
                        {value}
                      </li>
                    ))}
                </ul>
                <span
                  className="close-btnbyrs"
                  onClick={() => window.location.reload()}
                >
                  &times;
                </span>
              </div>
            )}
          </div>
          {/* <h2 className="allresult">
            <strong> All Property : </strong> {totalElements.toLocaleString()}{" "}
            results
          </h2> */}
          <div className="myflexxlks">
            <div className="resideciolbtn">
              <button
                onClick={() => {
                  setIsResidential(true);
                  fetchProperties(0, {}, null, true); // ✅ PASS TRUE
                }}
                className={isResidential ? "activeBtn" : ""}
              >
                <img src={Residin} alt="" /> Residential
              </button>
              <button
                onClick={() => {
                  setIsResidential(false);
                  fetchProperties(0, {}, null, false); // ✅ PASS FALSE
                }}
                className={!isResidential ? "activeBtn" : ""}
              >
                <img src={Vectors} alt="" /> Commercial
              </button>
            </div>
            <h2 className="allresult">
              <strong> Showing Property : </strong> {numberOfElements}{" "}
              <strong> of </strong>
              {!properties?.length || properties.length === 0
                ? 0
                : totalElements?.toLocaleString()}{" "}
              results
            </h2>
          </div>

          <div className="contents">
            {/*Property List */}
            <div
              className={`auctions-list ${
                mapOpen ? "with-map-grid" : "full-grid"
              }`}
              style={{ width: mapOpen ? "49%" : "100%" }}
            >
              {loading ? (
                <Loader />
              ) : properties.length > 0 ? (
                properties.map((prop) => (
                  <div
                    key={prop.id}
                    className={`auctions-card ${
                      mapOpen ? "with-map" : "full-width"
                    }`}
                  >
                    {/* Property card content remains the same */}
                    <div className="auctions-image">
                      <div
                        className="fav-icon position-absolute top-0 end-0 m-2"
                        onClick={() =>
                          toggleFavorite(prop.propeId, prop.id, prop.listingId)
                        }
                        style={{
                          cursor: "pointer",
                          borderRadius: "50%",
                          padding: "6px",
                        }}
                      >
                        <i
                          className={`fa${
                            favorites.includes(prop.id) ? "s" : "r"
                          } fa-heart`}
                          style={{
                            color: favorites.includes(prop.id) ? "red" : "#ccc",
                            fontSize: "27px",
                            transition: "color 0.2s ease",
                          }}
                        ></i>
                      </div>
                      <div className="imgexcue">
                        <img
                          src={
                            prop.propertyImages &&
                            prop.propertyImages.length > 0
                              ? prop.propertyImages[0].imageUrl
                              : placeimg
                          }
                          alt="property"
                        />
                      </div>
                    </div>

                    <div
                      className="auctions-info"
                      onClick={() => {
                        const listedBy =
                          prop.user?.name || prop.originatingSystemName;
                        const email = prop.user?.email || "";
                        handleViewDetails(prop.id, prop.propeId);
                      }}
                    >
                      <div className="auctions-details">
                        {prop.propertyType && (
                          <h1 className="listed-by">{prop.propertyType}</h1>
                        )}

                        {(prop.listingId || prop.propeId) && (
                          <h3 className="mls">
                            {prop.listingId ? (
                              <>
                                <strong>MLS No:</strong> {prop.listingId}
                              </>
                            ) : (
                              <>
                                <strong>Property Id:</strong> {prop.propeId}
                              </>
                            )}
                          </h3>
                        )}

                        {(prop.user?.name || prop.originatingSystemName) && (
                          <p className="listed-by">
                            Listed by{" "}
                            <span>
                              {prop.user?.name || prop.originatingSystemName}
                            </span>
                          </p>
                        )}

                        <h3 className="address">
                          {prop.unparsedAddress || "No Address"}
                        </h3>
                        <div className="property-specs">
                          {prop.bedroomsTotal > 0 && (
                            <span className="spec">
                              🛏{prop.bedroomsTotal}bed
                            </span>
                          )}

                          {prop.bathroomsTotalInteger > 0 && (
                            <span className="spec">
                              🛁{prop.bathroomsTotalInteger}bath
                            </span>
                          )}

                          {prop.lotSizeArea > 0 && (
                            <span className="spec">📐{prop.lotSizeArea}ft</span>
                          )}
                        </div>
                        {!(
                          !prop.biddingDetails ||
                          prop.biddingDetails.isBidEnd === true
                        ) && (
                          <p className="listed-by kiojkio">
                            Listing Price{" "}
                            <span>${formatNumberCA(prop.listPrice)}</span>
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="bgfix">
                      <div className="CURENTS">
                        <div className="price-section">
                          <p className="price-label">
                            <p className="price-label">
                              {prop.biddingDetails == null
                                ? "Listing Price"
                                : prop.isBidEnd === false
                                  ? "Listing Price"
                                  : "Current Offer Price"}
                            </p>
                          </p>

                          {/* <p className="price-label">Current Listing Price</p> */}
                        </div>

                        <h4 className="prices">
                          {(() => {
                            const details = prop.biddingDetails;

                            // CASE 1: If biddingDetails exists
                            if (details) {
                              // If bid has ended → show listPrice
                              if (
                                details.isBidEnd !== null &&
                                details.isBidEnd === true
                              ) {
                                return `$${formatNumberCA(prop.listPrice)}`;
                              }

                              // If bid NOT ended → show currentAuctionAmount OR offerStartingPrice
                              return `$${formatNumberCA(
                                details.currenntAuctionAmount ??
                                  details.offerStartingPrice,
                              )}`;
                            }

                            // CASE 2: If biddingDetails does NOT exist → show listPrice
                            return `$${formatNumberCA(prop.listPrice)}`;
                          })()}
                        </h4>
                      </div>
                      <div className="timebtn">
                        <Countdown
                          start={prop.biddingDetails?.bidingStartDateTime}
                          end={prop.biddingDetails?.bidingEndDateTime}
                        />

                        <button
                          className="view-btn"
                          onClick={() => {
                            const listedBy =
                              prop.user?.name || prop.originatingSystemName;
                            const email = prop.user?.email || "";
                            handleViewDetails(prop.id, prop.propeId);
                          }}
                        >
                          View Details
                        </button>
                      </div>
                    </div>

                    {prop.propeId !== null &&
                      prop.propeId !== undefined &&
                      prop.propeId !== "" &&
                      prop.propeId !== "null" && (
                        <div
                          className="position-absolute top-0 start-0 text-white px-2 py-1 small m-2 rounded"
                          style={{ background: "rgb(203 35 34)" }}
                        >
                          Exclusive
                        </div>
                      )}

                    {/* <img src={prop.isResidential ? Residin : Vectors} className="vtrimg" alt="" />
                     */}
                    <img
                      src={isResidential ? Residin : Vectors}
                      className="vtrimg"
                      alt=""
                    />
                  </div>
                ))
              ) : (
                <p style={{ textAlign: "center" }}>
                  <img src={Noprop} className="noporopty" />
                </p>
              )}
            </div>

            {/*Map View*/}
            {mapOpen && (
              <div className="map-box">
                {/* ✅ CUSTOM FULL MAP BUTTON */}
                <button
                  className="open-full-map-btn"
                  onClick={() =>
                    window.open("/map", "_blank", "noopener,noreferrer")
                  }
                >
                  ⛶
                </button>
                <LoadScriptNext
                  googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                  libraries={["places"]}
                >
                  {/* MAP COMPONENT */}
                  <MapComponent
                    listLocations={pagedMapLocations}
                    mapIsOpen={mapOpen}
                    mapCenter={mapCenter}
                    showNearby={showNearby}
                  />
                </LoadScriptNext>
              </div>
            )}
          </div>

          <div className="buyerpagenation">
            {/* Pagination */}
            {totalPages > 1 && (
              <div className="pagination">{renderPaginationButtons()}</div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Buyers;
